import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-mapper-library',
  template: `
    <p>
      mapper-library works!
    </p>
  `,
  styles: [
  ]
})
export class MapperLibraryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
